import {
  BarChart3,
  Briefcase,
  Calendar,
  FileText,
  FolderOpen,
  Mail,
  Settings,
  ShieldCheck,
  Video,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  key: string;
  labelKey: string;
  path: string;
  icon: LucideIcon;
  roles?: string[];
}

export const NAV_ITEMS: NavItem[] = [
  {
    key: 'jobPostings',
    labelKey: 'nav.jobPostings',
    path: '/job-postings',
    icon: Briefcase,
  },
  {
    key: 'submissions',
    labelKey: 'nav.submissions',
    path: '/dashboard',
    icon: FileText,
  },
  {
    key: 'documents',
    labelKey: 'nav.documents',
    path: '/documents',
    icon: FolderOpen,
  },
  {
    key: 'documentPolicies',
    labelKey: 'nav.documentPolicies',
    path: '/document-policies',
    icon: ShieldCheck,
    roles: ['admin'],
  },
  {
    key: 'promptSets',
    labelKey: 'nav.promptSets',
    path: '/prompt-sets',
    icon: Video,
    roles: ['admin'],
  },
  {
    key: 'scheduling',
    labelKey: 'nav.scheduling',
    path: '/scheduling',
    icon: Calendar,
  },
  {
    key: 'notificationTemplates',
    labelKey: 'nav.notificationTemplates',
    path: '/notification-templates',
    icon: Mail,
    roles: ['admin'],
  },
  {
    key: 'reports',
    labelKey: 'nav.reports',
    path: '/reports',
    icon: BarChart3,
  },
  {
    key: 'settings',
    labelKey: 'nav.settings',
    path: '/settings',
    icon: Settings,
    roles: ['admin'],
  },
];

export function getVisibleNavItems(userRole?: string): NavItem[] {
  return NAV_ITEMS.filter((item) => {
    if (!item.roles) {
      return true;
    }
    return userRole ? item.roles.includes(userRole) : false;
  });
}
